export const stringField = {
  control: 'text',
  showHint: false,
  valueUpdate: 'input',
  validators: {
    maxLength: { blockInput: false /* , message */ },
  },
};
